import { getDetailedVacancyFromMindkey, getVacanciesFromMindkey } from './connector';

export const getVacancies = async ({ customerId }: { customerId: string }): Promise<Mindkey.VacancySimple[]> => {
	try {
		return await getVacanciesFromMindkey({ customerId });
	} catch (error) {
		throw new Error(`Could not get vacancies \nCause: ${error}`, { cause: error });
	}
};

export const getVacancyDetail = async ({
	customerId,
	id,
	locale,
}: {
	customerId: string;
	id: string;
	locale: string;
}): Promise<Mindkey.VacancyDetail> => {
	try {
		return await getDetailedVacancyFromMindkey({ customerId, id, locale });
	} catch (error) {
		throw new Error(`Could not get vacancy detail\nCause: ${error}`, { cause: error });
	}
};
